<template>

    <div class="message" :class="css">
        <slot />
    </div>

</template>

<script>

export default {

    props: ['type'],

    computed: {
        
        css: function() {
            if ( this.type ) {
                return `message--${this.type}`
            }
            return ''
        }
    }
}
</script>

<style scoped>

.message {
    display: block;
    width: 100%;

    background-color: transparent;
    border-radius: 0.125rem;
    color: inherit;
    font-size: 110%;
    font-weight: 700;
    
    &:not(:last-child) {
        margin-bottom: 2rem;
    }

    ul, li {
        list-style-type: none;
        margin: 0;
        padding: 0;
    }
}

.message--important,
.message--info,
.message--success {
    padding: 1.3rem 1.2rem;
}

.message--important {
    background-color: rgb(255, 127, 93);
    color: rgba(0, 0, 0, 0.6);
}

.message--info {
    background-color: #ebf9ff;
    color: #005980;
}

.message--success {
    background-color: #d6f9e2;
    color: #006b5b;
}

</style>